module.exports = __webpack_public_path__ + "static/media/my-trips.422cb7c7.svg";